import React, { ReactNode } from 'react';
import REText from '@components/wrappedBDS/REText';
import { getCurrentThemeConfig } from '@app/core/theme-config';

interface LineItemProps {
  label: string;
  caption: string;
  id: string | ReactNode;
}

const LineItem: React.FC<LineItemProps> = ({ label, caption, id }) => {
  return (
    <div className="flex">
      <REText
        variant={getCurrentThemeConfig().lineItemLabelVariant}
        id={`office-label_${id}`}
        className="mr-2 flex"
      >
        {label}
      </REText>
      <REText variant={getCurrentThemeConfig().lineItemCaptionVariant} id={`office-caption_${id}`}>
        {caption}
      </REText>
    </div>
  );
};

export default LineItem;
